// src/components/black-friday/agent-promo-banner.tsx
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, BarChart3, Brain, Zap } from "lucide-react";

export default function AgentPromoBanner() {
  return (
    <Card className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950/20 dark:to-indigo-950/20 border-blue-200 dark:border-blue-800">
      <CardContent className="pt-8">
        {/* Main Headline */}
        <h2 className="text-3xl font-bold mb-8">Want to future-proof your career?</h2>

        {/* Three Column Layout: 3:1:2 ratio */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
          {/* Left Column (3/6) - Ads to AI Focus */}
          <div className="md:col-span-3 space-y-4">
            <div className="space-y-3">
              <p className="text-base font-semibold text-foreground leading-relaxed">
                Do you feel like your Google Ads skills are becoming obsolete? Do you have a nagging feeling that you need to provide more than just Google Ads management to your clients? Do you understand AI as well as you think you need to heading into 2026?
              </p>
              <p className="text-base text-foreground leading-relaxed">
                <strong>Ads to AI</strong> is the exclusive community where Google Ads experts become AI pioneers. Learn to build agents, automate workflows, and stay ahead of the curve. AI isn't coming for your job—it's transforming it. Become the person who builds AI solutions instead of competing with them.
              </p>
              <ul className="text-base text-foreground leading-relaxed space-y-1 list-disc pl-5">
                <li>Exclusive 8020brain access (Dec 2025)</li>
                <li>Interactive AI progression roadmap</li>
                <li>Monthly AI masterclass webinars</li>
                <li>Private Circle community access</li>
                <li>25-minute strategy call with Mike</li>
                <li>Weekly AI implementation videos</li>
                <li>PMax tools and script snippets</li>
                <li>Custom AI prompt library</li>
                <li>Quarterly expert guest sessions</li>
                <li>Implementation templates and frameworks</li>
                <li>Priority beta feature access</li>
              </ul>
            </div>
            <div className="pt-2">
              <Button size="lg" className="gap-2" asChild>
                <a href="https://mikerhodes.com.au/ai" target="_blank" rel="noopener noreferrer">
                  Join Ads to AI Community
                  <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
            </div>
          </div>

          {/* Middle Column (1/6) - Amphi Image */}
          <div className="md:col-span-1 flex items-center justify-center">
            <img
              src="/images/amphi.webp"
              alt="Mike Rhodes"
              className="w-full aspect-square object-cover rounded-lg"
            />
          </div>

          {/* Right Column (2/6) - 8020agent Info */}
          <div className="md:col-span-2 space-y-4">
            <h3 className="text-xl font-normal text-foreground">Want more Google Ads Insights?</h3>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="mt-1">
                  <BarChart3 className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-normal mb-1">Data Visualization</h4>
                  <p className="text-sm text-muted-foreground">
                    View your Google Ads data in innovative ways designed for profit optimization
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="mt-1">
                  <Zap className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-normal mb-1">Automated Scripts</h4>
                  <p className="text-sm text-muted-foreground">
                    Google Ads Scripts with comprehensive features for all campaign types
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="mt-1">
                  <Brain className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-normal mb-1">80/20 AI Insights</h4>
                  <p className="text-sm text-muted-foreground">
                    AI-powered analysis to find the 20% of actions that drive 80% of results
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-2">
              <Button size="lg" variant="outline" asChild>
                <a href="/" target="_blank" rel="noopener noreferrer">
                  Explore 8020agent Free
                </a>
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
